import Seat from './Seat/Seat.css';
import Passenger from './Passenger/Passenger.css';
import SeatMap from './SeatMap/SeatMap.css';
import Airplane from './Airplane/Airplane.css';
import SeatInfo from './SeatInfo/SeatInfo.css';
import SeatServiceSlide from './SeatServiceSlide/SeatServiceSlide.css';
const seatMapStyles = {
    SeatStyles: {
        seat: Seat.seat,
        seat_standart: Seat.standard,
        number: Seat.number,
        seat_preferred: Seat.preferred,
        seat_business: Seat.business,
        seat_occupied: Seat.occupied,
        seat_recommend: Seat.recommend,
        seat_recommendCurrent: Seat.recommend_current
    },
    SeatTooltipStyles: {
        tooltip: Seat.tooltip,
        tooltip_withInfo: Seat.tooltip_withInfo,
        info: Seat.tooltip__info
    },
    AirplaneInfoStyles: {
        sunInfo: Airplane.sunInfo
    },
    AirplaneStyles: {
        details: Airplane.details,
        airplane: Airplane.airplane,
        seatsDetails: Airplane.seatDetails
    },
    SeatsInfoStyles: {
        classInfo: SeatInfo.classInfo,
        seat: SeatInfo.seatInfo,
        classInfo__payload: SeatInfo.classInfo__payload,
        title: SeatInfo.seatInfo__title,
        description: SeatInfo.seatInfo__description,
        price: SeatInfo.seatInfo__money,
        feature: SeatInfo.seatInfo__feature,
        price__wrapper: SeatInfo.seatInfo__price,
        seat_economy: SeatInfo.seat_economy
    },
    SeatMapStyles: {
        row__serviceHeader: SeatMap.serviceHeader,
        row__serviceHeader__wrapper: SeatMap.serviceHeader__wrapper,
        row__serviceHeader_comfort: SeatMap.serviceHeader__comfort
    },
    Passenger: {
        item: Passenger.passenger,
        item_active: Passenger.active,
        avatar: Passenger.avatar,
        select: Passenger.select,
        payload: Passenger.payload,
        money: Passenger.money,
        item_recommend: Passenger.recommend,
        select_selected: Passenger.selected,
        seat: Passenger.seat
    },
    PassengersStyles: {
        recommend__price: Passenger.recommend__price,
        passengers__button: Passenger.recommend__confirm,
        recommend__label: Passenger.recommend__label
    },
    Controls: {
        button: SeatMap.button
    },
    SeatMapDisclaimerStyles: {
        disclaimer: SeatMap.disclaimer,
        disclaimer__icon: SeatMap.icon
    },
    SeatServiceSlide: {
        serviceInfo__slider: SeatServiceSlide.slider,
        clear: SeatServiceSlide.clear
    }
};
export default seatMapStyles;
